module.exports = __webpack_public_path__ + "images/ea872ca419290f8b83c0a18e2d382c60.svg";